import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownUserTypes = ( { control, name, rules, placeholder, suppressAdminUser, suppressDSLUser, isSearchable, isClearable, isMulti, readOnly } ) =>
{
    let url = '/ref/usertypes' ;

    if ( suppressAdminUser === true )
    {
        url += '?suppressAdmin'
    } else if ( suppressDSLUser === true )
    {
        url += '?suppressDSL'
    }

    const fields = { url: url, keyFieldName: 'user_type_id', labelFieldName: 'type_description' }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownUserTypes;
